<script>
import Base from '@/plans/ZOOM_ROOMS/config/base';
import { isFromShoppingCart, isProductCanRemove } from '@/views/config/shopping-cart/persist/plan-remove';

export default {
  extends: Base,
  computed: {
    licenseAlertDesc() {
      if(!this.zrAsBasePlan) return null;
      return this.mx_defLicenseAlertDesc;
    },
    canRmv() {
      if(isFromShoppingCart()) {
        return isProductCanRemove(this.selectedPlan)
      }
      return !this.zrAsBasePlan && this.$context.type !== this.planType;
    },
  },
};
</script>
